import React from "react";
import { useSelector } from "react-redux";
import {
  wpIsItem,
  wpIsCco,
  wpIsPendingIssue,
  getWpPrefix,
  getWpNumber,
} from "../utils/adrUtilsV3";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function AdrReviewWpDescHelpV3({ tabId, wpSortOrder, toggleWpHelp, showWpHelp }) {
  const adr = useSelector((state) => state.adr.openAdrs[tabId] || null);
  const projItemList = useSelector(
    (state) => state.bidItems.projItemLists[adr.projectId] || null
  );
  const projCcoList = useSelector(
    (state) => state.ccos.projCcoLists[adr.projectId] || null
  );
  const projPendingIssueList = useSelector(
    (state) => state.projPendingIssueLists[adr.projectId] || null
  );

  const getWpDescription = (wp) => {
    if (wpIsItem(wp) && projItemList) {
      const item = (projItemList || []).find((i) => i.bidItemId === wp.itemId);
      return item ? item.description : "";
    }
    if (wpIsCco(wp) && projCcoList) {
      const cco = (projCcoList || []).find((c) => c.ccoId === wp.ccoId);
      return cco ? cco.description : "";
    }
    if (wpIsPendingIssue(wp) && projPendingIssueList) {
      const pi = (projPendingIssueList || []).find(
        (pi) => pi.pendingIssueId === wp.pendingIssueId
      );
      return pi ? pi.description : "";
    }
    return "";
  };

  return (
    <div className="row">
      <div className="col-9">
        <div className="card mb-2">
          <div className="card-body p-3 bg-lightgreen">
            <div className="d-flex flex-row justify-content-between">
              <span className="h6 text-muted">
                <FontAwesomeIcon icon="question-circle" className="fa-fw mr-2" />
                View BI/CO/PI Description
              </span>
              <button
                type="button"
                name="toggleWpDescHelp"
                id="toggleWpDescHelp"
                className="btn btn-sm btn-link"
                onClick={() => toggleWpHelp(!showWpHelp)}
              >
                Dismiss
              </button>
            </div>
            <ul className="mb-0">
              {wpSortOrder &&
                wpSortOrder.map((wpSo) => (
                  <li key={`wpDescHelpLiKey_${wpSo.wpTabId}`}>
                    <span>
                      <b>
                        <small>
                          <b>{getWpPrefix(adr.workPerformedClient[wpSo.wpTabId])}</b>
                        </small>
                        {getWpNumber(
                          adr.workPerformedClient[wpSo.wpTabId],
                          projItemList,
                          projCcoList,
                          projPendingIssueList
                        )}
                        :{" "}
                      </b>
                    </span>
                    <span>{getWpDescription(adr.workPerformedClient[wpSo.wpTabId])}</span>
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-3 border-left"></div>
    </div>
  );
}
